require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;


//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.4.1@core-js/library/fn/object/assign.js
// module id = 152
// module chunks = 20